<template>
  <div class="mobile-dropdown" :class={open}>
    <div class="btn" @click="() => {open = !open}">
      {{ name }}
      <img :src="menuOpen" class="menu-icon-open" alt="Menu" />
      <img :src="menuClosed" class="menu-icon-closed" alt="Menu" />
    </div>

    <div class="dropdown">
      <div
        class="dropdown-item"
        v-for="item in items"
        :key="item.title"
        @click="() => onClick(item)"
      >
        <div class="dropdown-icon">
          <img :src="icons[item.icon]" alt="Icon" />
        </div>
        <div class="dropdown-cnt">
          <div class="body-md fsemibold">
            <a :href="item.link">
              <div class="dropdown-title">
                {{ item.title }}
              </div>

              <div class="ext-icon" v-if="item.isExt">
                <img :src="icons.extLinkIcon" alt="External link" />
              </div>

              <div class="new-badge" v-if="item.isNew">
                <div class="new-badge-cnt text-sm">Nouveau</div>
              </div>
            </a>
          </div>
          <div class="body-sm dropdown-desc">
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuOpen from "../../assets/menu-open.svg";
import menuClosed from "../../assets/menu-closed.svg";

import navIconProfile from "../../assets/nav-icon-profile.svg";
import navIconRecruiter from "../../assets/nav-icon-recruter.svg";
import navIconPublish from "../../assets/nav-icon-publish.svg";
import navIconAcademy from "../../assets/nav-icon-academy.svg";
import navIconClub from "../../assets/nav-icon-club.svg";
import navIconBlog from "../../assets/nav-icon-blog.svg";
import navIconGlossary from "../../assets/nav-icon-glossary.svg";
import navIconJobs from "../../assets/nav-icon-jobs.svg";
import extLinkIcon from "../../assets/ext-link.svg"

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,

      menuOpen,
      menuClosed,

      icons: {
        navIconProfile,
        navIconRecruiter,
        navIconPublish,
        navIconAcademy,
        navIconClub,
        navIconBlog,
        navIconGlossary,
        navIconJobs,
        extLinkIcon,
      },
    };
  },
  methods: {
    onClick(item) {
      if(item.isExt) {
        window.open(item.link, '_blank');
      } else {
        window.location.href = item.link;
      }
    },
  },
};
</script>

<style lang="scss">
.mobile-dropdown {
  display: block!important;
  padding: 0!important;
  
  & > * {
    display: block;
  }

  .btn {
    background: $neutral50;
    width: 100%;
    cursor: pointer;
    color: $neutral900;
    text-align: left;
    padding: 16px 24px;

    .menu-icon-open,
    .menu-icon-closed {
      float: right;
      width: 24px;
      height: 24px;
    }

    .menu-icon-open {
      display: none;
    }
  }
      
  .dropdown {
    height: 0;
    // transition: height 0.3s ease-in-out;
    overflow-y: hidden;
    background: white;

    .dropdown-item {
      padding: 16px 24px;
      cursor: pointer;
      text-align: left;

      .dropdown-icon {
        margin-right: 16px;
        width: 24px;
        height: 24px;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .dropdown-cnt {
        float: left;
        width: 100%;

        a {
          text-decoration: none;
          color: $neutral900;
        }

        .ext-icon {
          margin-left: 8px;
          float: right;
        }

        .dropdown-title {
          float: left;
        }

        .new-badge {
          float: left;
          position: relative;
          top: 2px;

          margin-left: 8px;
          padding: 0 12px;

          border-radius: 16px;
          background: $primary25;
          mix-blend-mode: multiply;

          .new-badge-cnt {
            text-align: center;
            color: $primary400;

            font-family: "Inter";
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
          }
        }

        .dropdown-desc {
          clear: both;
          margin-top: 4px;
          color: $neutral600;
        }
      }

      &::after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }

  &.open {
    .trigger {
      .btn {
        .menu-icon-open {
          display: block;
        }

        .menu-icon-closed {
          display: none;
        }
      }
    }

    .dropdown {
      height: 100%;
    }
  }
}
</style>